module.exports = __webpack_public_path__ + "fonts/fa-brands-400.8300bd7f.ttf";